<template>
  <footer :class="$style.footer">
    <div :class="$style.footerContent">
      <div>
        <img
          width="150"
          loading="lazy"
          src="@/assets/images/Cuprum_Logo_Positivo.svg"
          alt="cuprum_logo" />
      </div>
      <div :class="$style.infoContainer">
        <contactNumber></contactNumber>
        <div :class="$style.vlineOne"></div>
        <div :class="$style.linksContainer">
          <div :class="$style.links">
            <a :class="$style.link"
            tabindex="16"
            aria-label="Políticas de Privacidad, enlace"
            href="https://www6.cuprum.cl/sites/default/files/inline-files/CD528%20Cuprum%20-%20Pol%C3%ADtica%20Privacidad%20del%20Sitio%20Web%20V5.pdf"
            rel="nofollow" target="_blank">
            Políticas de Privacidad</a>
          </div>
          <div :class="$style.vLine"></div>
          <div :class="$style.links">
            <a :class="$style.link"
            tabindex="17"
            aria-label="Políticas de Seguridad, enlace"
            href="https://www6.cuprum.cl/sites/default/files/inline-files/CD805%20Pol%C3%ADtica%20de%20Seguridad%20del%20Sitio%20Cuprum%20V2.pdf"
            rel="nofollow" target="_blank">
            Políticas de Seguridad</a>
          </div>
        </div>
      </div>
    </div>
    <div :class="$style.subFooterContent">
      <div :class="$style.logoSuper">
        <img loading="lazy" src="@/assets/images/logo-sp.svg" alt="logo_sp" />
      </div>
      <div :class="$style.textSuper">
        Entrega tu opinión sobre la calidad del servicio de tu AFP en
        <a
        tabindex="18"
        aria-label="Entrega tu opinión a la Superintendencia de
        Pensiones sobre la calidad del servicio de tu AFP en esta encuesta, enlace externo."
        :class="$style.linkSuper" href="http://www.spensiones.cl/infoydec"
        rel="nofollow"
        target="_blank">
        esta encuesta.</a>
      </div>
    </div>
    <div :class="$style.subSubfooterContent">
      <span
      tabindex="19"
      aria-label="Todos los derechos reservados">Todos los derechos reservados</span>
    </div>
  </footer>
</template>

<script>
import contactNumber from '../ContactNumber';

export default {
  name: 'Footer',
  components: {
    contactNumber,
  },
  data() {
    return {
      size: 0,
    };
  },
};
</script>

<style lang="scss" module>

.footer {
  position: relative;
  width: 100%;
  background-color: #f6f6f8;

  & .footerContent {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    max-width: 1440px;
    padding: 0 24px;
    margin: 0 auto;

    & .infoContainer {
      display: flex;
      flex-direction: row-reverse;

      & .vlineOne {
        height: 48px;
        margin-top: 26px;
        border: 0.5px solid #c5c6c5;
      }

      & .linksContainer {
        display: flex;
        flex-direction: row;
        align-items: center;

        & .vLine {
          height: 48px;
          border: 0.5px solid #c5c6c5;
        }

        & .links {
          position: relative;
          top: -14px;
          padding: 0 32px;

          & .link {
            font-size: 14px;
          }

          & .link:hover {
            height: 20px;
            font-size: 14px;
            border-bottom: 1px solid #0061a0;
          }
        }
      }
    }
  }

  & .subFooterContent {
    display: flex;
    justify-content: center;
    padding: 12px 24px 8px;
    background-color: #e8e8e8;

    & .logoSuper {
      margin: 6px 16px 0 0;
    }

    & .textSuper {
      line-height: 36px;

      & .linkSuper {
        height: 20px;
        font-size: 14px;
      }

      & .linkSuper:hover {
        height: 20px;
        font-size: 14px;
        border-bottom: 1px solid #0061a0;
      }
    }
  }

  & .subSubfooterContent {
    padding: 24px 0;
    text-align: center;
    background-color: #f6f6f8;
  }

  a {
    color: #0061a0;
  }
}

@media (max-width: 990px) {
  .footer {
    justify-content: center;
    padding-top: 24px;
    text-align: center;

    & .footerContent {
      display: inherit;

      & .infoContainer {
        display: inherit;

        & .vlineOne {
          display: none;
        }

        & .linksContainer {
          justify-content: center;
          margin-top: 8px;

          & .vLine {
            position: relative;
            top: -13px;
            height: 16px;
          }
        }
      }
    }

    & .subFooterContent {
      display: block;
      padding: 12px 24px 24px;

      & .logoSuper {
        margin: 6px 16px 8px 0;
      }

      & .textSuper {
        line-height: 18px;
      }
    }
  }
}
</style>
